module.exports = __webpack_public_path__ + "static/img/Dion-Prestia.d39ad44.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Dion-Prestia.jpg
// module id = aCUw
// module chunks = 0